<template>
<m-pageframe
    title="Start Report"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="250"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickRunReport(item)"
                >
                    <v-list-item-title>Run Report...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    <m-report-progress-dialog
        ref="progress-dialog"
     />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,

            headers: [
                { text: 'Id', value: 'report_id'},
                { text: 'Label', value: 'label'},
                { text: 'Action', value: 'action'},
            ],

            results: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/reports/meta-data',
            
                'params' : {
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list report meta data',
            });
        },
        
        onClickRunReport(item)
        {
            if ( this.$rc.inDev() )
            {
                this.onClickRunReportInDev(item);
                return;
            }

            this.$rc.confirm({
                'title': 'Start Report: '+item.label,
                'body': 'Start the report: '+item.label,
                'btn_text_ok': 'Run Report',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.runReport(item.report_id, null);
                },
            });
        },

        onClickRunReportInDev(item)
        {     
            this.$rc.pick({
                'title': 'Choose Database',
                'content_before': '',
                'content_after': null,
            
                'choices': ['dev','staging','production'],
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Choose Database',
                'initial_value': 'dev',
                'unset_label': null,
            
                'on_ok': (value) => {
                    this.runReport(item.report_id, value);
                },
            
                'on_cancel': () => {}
            
            });
        },

        runReport(report_id, database)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/reports/run',
            
                'params' : {
                        'report_id': report_id,
                        'database': database,
                    },
            
                'on_success': (data) => {
                        this.$refs['progress-dialog'].showDialog(data);
                    },
            
                'on_error': 'Unable to start report',
            });
        }
    },
}
</script>

<style lang="scss" scoped>
</style>